import styled from 'styled-components';
import { darken } from 'library/util/css';

export const StyledWidget = styled.div`
  border-top: 5px solid #207c9d;
  height: ${(props) => (props.height ? props.height : '276px')};
  width: 428px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.11);
  position: relative;
  overflow: hidden;
  padding: 1em;
  margin-bottom: 2em;
  h3 {
    margin-top: 0;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: -0.05px;
    line-height: 26px;
    color: ${(props) => props.theme.colors.grey1};
  }
  @media (max-width: 500px) {
    width: 99%;
  }
  transition: height 0.2s ease-out;
`;

export const StyledWidgetLoading = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const StyledWidgetButton = styled.button`
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 384px;
  border-radius: 4px;
  background-color: #dbf2ef;
  border: 0;
  color: #1e4c47;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.16px;
  line-height: 17.6px;
  text-transform: none;
  margin-left: 8px;
  margin-top: ${(props) => props.topMargin || '0'};
  &&& :hover {
    text-transform: none;
    border: 0;
    background: ${darken('#DBF2EF', 0.1)};
  }
  @media (max-width: 500px) {
    width: 95%;
  }
  &:focus {
    ${(props) =>
      props.isTabbing ? 'outline: #005FCC auto 1px;' : 'outline: none;'}
  }
`;

export const StyledFakeList = styled.div`
  filter: grayscale(1);
  opacity: 0.05;
  position: relative;
`;

export const StyledWidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  h3 {
    margin: 0;
  }
`;

export const StyledNoSurveyText = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: 21%;
  top: 35%;
  h4 {
    margin: 0;
    color: ${(props) => props.theme.colors.grey1};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
  }
  p {
    color: ${(props) => props.theme.colors.grey2};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
`;
